import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ClassService, ConfigService, ScriptLoaderService } from './../../../../../../_services';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SwalComponent, SwalPartialTargets } from '@toverux/ngx-sweetalert2';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvestorDocument } from '../../../../../../_models/investorDocument';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';


@Component({
    selector: 'app-configs-investor-document-modal',
    templateUrl: './configs-investor-document-modal.component.html',
    styles: ['.select2-search__field { with:100% !important; }']
})
export class ConfigsInvestorDocumentModalComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() investorDocument_id: number;
    public model = new InvestorDocument(null, null, null, null, null, null, null);
    public investorDocument: any[];
    public errors: string;
    form: FormGroup;


    @BlockUI() blockUI: NgBlockUI;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('errorsListSwal') private errorsListSwal: SwalComponent;

    constructor(private _configService: ConfigService,
        private _script: ScriptLoaderService,
              /*private _modalService: NgbModal*/) {
        this.form = new FormGroup({
            name: new FormControl(),
            file_types: new FormControl(),
            people_types: new FormControl(),
            required: new FormControl(),
            apply_foreign: new FormControl(),
            description: new FormControl(),
        });
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this._script.loadScripts('app-configs-investor-document-modal', ['assets/demo/demo2/custom/crud/forms/widgets/select2.js']);
        ($('.people_types') as any).select2({
            data: [{ id: 'FISICA', text: 'Física' }, { id: 'MORAL', text: 'Moral' }]
        });
        ($('.file_types') as any).select2({
            data: [{ id: '.jpg', text: 'JPG' }, { id: '.docx', text: 'DOCX' }, { id: '.jpeg', text: 'JPEG' }, { id: '.png', text: 'PNG' }, { id: '.doc', text: 'DOC' }, { id: '.pdf', text: 'PDF' }],
        });


    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.investorDocument_id)
            this.getInvestorDocument(this.investorDocument_id);
    }

    getInvestorDocument(id) {
        let file_types;
        let people_types;
        this.blockUI.start();
        this._configService.getInvestorDocument(id).subscribe(data => {
            this.investorDocument = data.data;
            file_types = this.investorDocument['file_types'];
            people_types = this.investorDocument['people_types'];

            $(".file_types").val(file_types.split(",")).trigger("change");
            $(".people_types").val(people_types.split(",")).trigger("change");
            this.blockUI.stop();


        }, err => {
            this.blockUI.stop();
        }, () => {

        });
    }

    updateInvestorDocument() {
        this.blockUI.start();
        this.investorDocument['name'] = this.form.controls.name.value;
        this.investorDocument['file_types'] = ($('.file_types') as any).select2("val").toString();
        this.investorDocument['description'] = this.form.controls.description.value;
        this.investorDocument['people_types'] = ($('.people_types') as any).select2("val").toString();
        this.investorDocument['required'] = this.form.controls.required.value;
        this.investorDocument['apply_foreign'] = this.form.controls.apply_foreign.value;
        this._configService.putInvestorDocument(this.investorDocument_id, this.investorDocument).subscribe(response => {
            this.blockUI.stop();
            this.successSwal.text = response.message;
            this.successSwal.show();

        }, error => {
            this.errors = error.error.error.errors;
            this.errorsListSwal.show();
            this.blockUI.stop();
        }, () => {

        });
    }

    reload() {
        window.location.reload();
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs-modals/investor-document-modal/configs-investor-document-modal.component.ts